import { IconContext } from "react-icons";
import { useTheme } from "styled-components";
import { useTheme as useCustomTheme } from "../Theme/ThemeProvider.js";
import { useState } from "react";
import { FiMenu, FiX } from "react-icons/fi";
import {
  Nav,
  NavbarContainer,
  NavLogo,
  NavIcon,
  ThemeSwitchContainer,
  Slider,
  IconContainer,
  NavItem,
  NavMenu,
  NavBtnLink,
  MobileIcon,
} from "./styles.js";

export default function Navbar() {
  const theme = useTheme();
  const { isDarkMode, toggleTheme } = useCustomTheme();

  const [showMobileMenu, setShowMobileMenu] = useState(false);

  const toggleMobileMenu = () => {
    setShowMobileMenu((prev) => !prev);
  };

  return (
    <IconContext.Provider value={{ color: "#FAFAFA" }}>
      <Nav isDarkMode={isDarkMode}>
        <NavbarContainer>
          <NavLogo to="/">
            <NavIcon
              src={
                isDarkMode
                  ? "/assets/dark/primatio-dark.png"
                  : "/assets/light/primatio-light.png"
              }
              alt="logo"
            />
          </NavLogo>

          <NavMenu show={showMobileMenu}>
            <NavItem>
              <NavBtnLink to="/" onClick={() => setShowMobileMenu(false)}>
                Vault
              </NavBtnLink>
            </NavItem>
            <NavItem>
              <NavBtnLink
                to="/empresa"
                onClick={() => setShowMobileMenu(false)}
              >
                Empresa
              </NavBtnLink>
            </NavItem>
            <NavItem>
              <NavBtnLink
                to="/quem-somos"
                onClick={() => setShowMobileMenu(false)}
              >
                Quem Somos
              </NavBtnLink>
            </NavItem>
            {/* <NavItem>
              <NavBtnLink
                to="/contatos"
                onClick={() => setShowMobileMenu(false)}
              >
                Contatos
              </NavBtnLink>
            </NavItem> */}
          </NavMenu>
          <ThemeSwitchContainer
            className="theme-switch"
            isDarkMode={isDarkMode}
            onClick={toggleTheme}
          >
            <Slider isDarkMode={isDarkMode}>
              <IconContainer isDarkMode={isDarkMode}>
                <img
                  src={
                    isDarkMode
                      ? "/assets/dark/moon-icon-dark.png"
                      : "/assets/light/sun-icon-light.png"
                  }
                  alt={isDarkMode ? "Moon Icon" : "Sun Icon"}
                  style={{
                    width: "16px",
                    height: "16px",
                    transition: "transform 0.3s ease",
                  }}
                />
              </IconContainer>
            </Slider>
          </ThemeSwitchContainer>

          <MobileIcon className="mobile-icon" onClick={toggleMobileMenu}>
            {showMobileMenu ? (
              <FiX size={24} color={theme.text} />
            ) : (
              <FiMenu size={24} color={theme.text} />
            )}
          </MobileIcon>
        </NavbarContainer>
      </Nav>
    </IconContext.Provider>
  );
}
